export function applicationFormPage($) {
    console.log("applicationFormPage loaded");

     //modal start here
      $("[data-modal-open]").on("click", function () {
        let modalId = $(this).data("modal-open");
        resetForm()
        openModal(modalId);
      });

      $(".modal--close, .overlay, .close").on("click", function () {
        resetForm()
        $(".modal, .overlay").removeClass("show");
        $("body").removeClass("block");
      });
      //modal end here
    
    $("#name_career").on("keypress keyup", function (event) {
        var inputValue = event.which;
        if (
            !(inputValue >= 65 && inputValue <= 122) &&
            inputValue != 32 &&
            inputValue != 0
        ) {
            event.preventDefault();
        }
        var checkText = $(this).val();
        $(this).val(checkText.replace(/[^a-zA-Z ]/g, ""));
    });

    $("#number_career").on("keypress keyup", function (event) {
      var inputValue = $(this).val().replace(/[^0-9]/g, '');

      if (inputValue.length >= 10) {
          event.preventDefault();
        }
        if (event.which < 48 || event.which > 57) {
          event.preventDefault();
        }
      
    });

    $("#file_career").on("change", function(e){
        var fileName = $('.filename')
        fileName.html(e.target.files[0].name)
        
    })

    $('input[name="relocation"]').on('change',function(){
       var value =  $(this).val()
        console.log(value, 'value');
        
    })

    $('#applicationForm').on('submit', function(e) {
        e.preventDefault();
        var cname = $('input[name="careername"]').val()
        var cnumber = $('input[name="careernumber"]').val()
        var clocation = $('input[name="careerlocation"]').val()
        var capplication = $('#applicationCode').val()
        var experience = $('#exp_career').val()
        var noticePeriod = $('#notice_career').val()
        var cannualCtc = $('#ctc_career').val()
        var eanuualCtc = $('#ectc_career').val()
        var resume = $('#file_career').val()
        var radio = $('input[name="relocation"]')
        var referrer_name = $('#referrer_career').val()
        var fileInput = $('#file_career')[0]; 
        var file = fileInput.files[0];
        var mobileRegex = /^[6-9]\d{9}$/;
        var regex = /^\d*(\.\d{0,2})?$/;
        var numberRegex = /^[0-9]*$/;
        var validName = true;
        var validNumber = true;
        var validLocation = true;
        var validApplication = true;
        var validExperience = true;
        var validNoticePeriod = true;
        var validCAnnualCtc = true;
        var validEAnnualCtc = true;
        var validRelocation = true;
        var validResume = true;
        var maxSizeInBytes = 1.5 * 1024 * 1024;

        console.log(capplication, 'capplication');
        

        if(cname == ''){
            $('#cname_error').html('Please enter a valid name');
            validName = false
        }
        else if(cname.length < 3){
            $('#cname_error').html('Please enter at least 3 characters');
            validName = false
        }
        else{
            $('#cname_error').html('');
            validName = true
        }

        if(clocation == ''){
            $('#clocation_error').html('Please enter your location');
            validLocation = false
        }
        else{
            $('#clocation_error').html('');
            validLocation = true
        }

        if(capplication == '' || capplication == null){
            $('#capplication_error').html('Please enter a valid department');
            validApplication = false
        }
        else{
            $('#capplication_error').html('');
            validApplication = true
        }

        if((!regex.test(experience)) ||experience == ''){
            $('#cexp_error').html('Please enter your experience');
            validExperience = false
        }
        else{
            $('#cexp_error').html('');
            validExperience = true
        }

        if(cannualCtc == ''){
            $('#cctc_error').html('Please enter your current annual ctc');
            validCAnnualCtc = false
        }
        else if(!regex.test(cannualCtc)){
            $('#cctc_error').html('Please enter valid current annual ctc');
            validCAnnualCtc = false
        }
        else{
            $('#cctc_error').html('');
            validCAnnualCtc = true
        }

        if(eanuualCtc == ''){
            $('#cectc_error').html('Please enter your expected annual ctc');
            validEAnnualCtc = false
        }
        else if(!regex.test(eanuualCtc)){
            $('#cectc_error').html('Please enter valid expected annual ctc');
            validEAnnualCtc = false
        }
        else{
            $('#cectc_error').html('');
            validEAnnualCtc = true
        }

        if((radio[0].checked || radio[1].checked) == false){
            $('#relocation_error').html('Please select relocation');
            validRelocation = false
        }
        else{
            $('#relocation_error').html('');
            validRelocation = true
        }

        if(noticePeriod == ''){
            $('#cnotice_error').html('Please enter your notice period in days');
            validNoticePeriod = false
        }
        else if(!numberRegex.test(noticePeriod)){
            $('#cnotice_error').html('Please enter valid notice period in days');
            validNoticePeriod = false
        }
        else{
            $('#cnotice_error').html('');
            validNoticePeriod = true
        }

        if(cnumber == ''){
            $('#cnumber_error').html('Please enter a valid number');
            validNumber = false
        }
        else if(!mobileRegex.test(cnumber)){
            $('#cnumber_error').html('Please enter 10 digit valid mobile number')
            validNumber = false
        }
        else{
            $('#cnumber_error').html('');
            validNumber = true
        }

        if(!file){
            $('#cfile_error').html('Please upload your resume');
            validResume = false
        }
        else if(file.size > maxSizeInBytes){
            $('#cfile_error').html('File must be less than 1.5 MB');
            validResume = false
        }
        else{
            $('#cfile_error').html('');
            validResume = true
        }
        

        if(validName && validNumber && validLocation && validApplication && validNoticePeriod && validExperience && validResume && validCAnnualCtc && validEAnnualCtc && validRelocation && validResume) {
            var formData = new FormData()
            formData.append("name", cname);
            formData.append("mobile_number", cnumber);
            formData.append("location", clocation);
            formData.append("department", capplication);
            formData.append("total_experience", experience);
            formData.append("notice_period", noticePeriod);
            formData.append("current_annual_ctc", cannualCtc);
            formData.append("expected_annual_ctc", eanuualCtc);
            formData.append("referrer_name", referrer_name);
            formData.append("relocation", radio.val());
            formData.append("attachment", file);
            // var careerFormData = {
            //     name: cname,
            //     mobile_number : cnumber,
            //     department: capplication,
            //     total_experience : experience,
            //     location : clocation,
            //     notice_period : noticePeriod,
            //     current_annual_ctc : cannualCtc,
            //     expected_annual_ctc : eanuualCtc,
            //     referrer_name : referrer_name,
            //     attachment : file,
            //     relocation : radio.val()
            // }
            // var formData = $.param(careerFormData);
            // console.log(formData, 'formData');
            
            $.ajax({
                type: 'POST',
                url: 'https://www.pivotroots.com/api/submit-application', //for live
                // url: 'https://uat.pivotroots.in/api/submit-application', // for uat
                data: formData,
                processData: false,
                contentType: false,
                success: function(response) {
                    console.log(response, 'response');
                    if(response.status == 'success'){
                        resetForm()
                        $('#applicationForm')[0].reset();
                        $('[data-modal-id="career_form"').removeClass("show");
                        $('[data-modal-id="thank_popup"').addClass("show");
                    }
                    else{
                        console.log('please fill proper data', response);
                        
                    }
                    // alert('Application submitted successfully!');
                },
                error: function(xhr, status, error) {
                    console.error('Submission failed:', error);
                    alert('An error occurred while submitting the application.');
                }
            });
        }
    })

    function resetForm() {
      var form = $('#applicationForm');

      form[0].reset(); // Reset inputs

        $('input[name="careername"]').val()
        $('input[name="careernumber"]').val()
        $('input[name="careerlocation"]').val()
        $('#applicationCode').val()
        $('#exp_career').val()
        $('#notice_career').val()
        $('#ctc_career').val()
        $('#ectc_career').val()
        $('#file_career').val()

        $('#cfile_error').html('');
        $('#cnumber_error').html('');
        $('#cnotice_error').html('');
        $('#relocation_error').html('');
        $('#cectc_error').html('');
        $('#cctc_error').html('');
        $('#cexp_error').html('');
        $('#capplication_error').html('');
        $('#cname_error').html('');
        $('#clocation_error').html('');
        $('.filename').html(`Upload CV* <span class="color--grey font--16 margin--l10">(doc, pdf, docx)</span>`);
    }

     

    function openModal(modalId) {
        $("body").addClass("block");
        $('[data-modal-id="' + modalId + '"], .overlay').addClass("show");
    }
}